export const companyRoutes = {
  list: "",
  new: "new",
  edit: ":id/edit",
  bulkUpload: "import",
} as const;
